import React from 'react'
import { Form, Switch } from 'antd'
import { useLingui } from '@lingui/react/macro'

import InfoPopover from '@/pages/tad.ai/_components/InfoPopover'


import { cls } from 'tagged-classnames-free';
function InstrumentalSwitchField() {
  const { t } = useLingui()

  return (
    <Form.Item label={null}>
      <div className={cls`flex items-center justify-between`}>
        <span className={cls`flex items-center gap-1`}>
          <span className={cls`text-f-text text-lg font-semibold`}>
            {t`Instrumental`}
          </span>
          <InfoPopover
            maxWidth={420}
            content={t`When this switch is off, your prompt determines whether the output is instrumental or includes vocals. When it's on, the output will always be instrumental.`}
          />
        </span>
        <Form.Item name='instrumental' valuePropName='checked' noStyle>
          <Switch size='small' />
        </Form.Item>
      </div>
    </Form.Item>
  )
}

export default InstrumentalSwitchField
